module.exports = __webpack_public_path__ + "static/img/shui1.934fc54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/shui1.jpg
// module id = h0tt
// module chunks = 0